import Swal from "sweetalert2";
import "./swalDialogs.css";

// App-styled SweetAlert2 dialogs (styles in swalDialogs.css).
const swalBase = {
  customClass: { container: "ds-swal", popup: "ds-swal__popup", confirmButton: "ds-swal__confirm", cancelButton: "ds-swal__cancel" },
  buttonsStyling: false,
  reverseButtons: true,
};

// Resolves true when the user confirms.
export const confirmDialog = async ({ title, text, html, confirmText = "Yes", cancelText = "No", danger = false }) => {
  const result = await Swal.fire({
    ...swalBase,
    icon: danger ? "warning" : "question",
    title,
    text,
    html,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    focusCancel: danger,
    customClass: { ...swalBase.customClass, confirmButton: `ds-swal__confirm${danger ? " is-danger" : ""}` },
  });
  return result.isConfirmed;
};

export const resultDialog = (icon, title, text) => Swal.fire({ ...swalBase, icon, title, text, timer: icon === "success" ? 1800 : undefined, showConfirmButton: icon !== "success", confirmButtonText: "OK" });

// Escapes user data before it goes into a SweetAlert `html` body.
export const escapeHtml = (value) => String(value ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
